import { Box, Button, Tooltip } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTranslation } from "react-i18next";
import { useRechnung } from "../../../client/queries";

export default function VerknuepfteRechnungLink({
  rechnungId,
}: {
  rechnungId?: string;
}) {
  if (!rechnungId) return null;
  return <RechnungLink rechnungId={rechnungId} />;
}

function RechnungLink({ rechnungId }: { rechnungId: string }) {
  const { t } = useTranslation("taetigkeitsbericht");
  const rechnung = useRechnung(rechnungId, { suspense: false });
  const url = `/eingangsrechnungen/${rechnungId}`;

  return (
    <Box component="span" sx={{ pl: 4 }}>
      <Tooltip title={t("linked-invoice-open-tooltip")}>
        {/* Als <a> gerendert, damit der Button auch in einem deaktivierten fieldset klickbar bleibt */}
        <Button
          component="a"
          href={url}
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<DescriptionIcon />}
          endIcon={<OpenInNewIcon fontSize="small" />}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            window.open(url, "_blank");
          }}
          sx={{ textTransform: "none", px: 2 }}
        >
          <Box component="span" sx={{ fontWeight: 600 }}>
            {rechnung
              ? rechnung.rechnungsNummer || t("linked-invoice-no-number")
              : t("linked-invoice-loading")}
          </Box>
        </Button>
      </Tooltip>
    </Box>
  );
}
